/*
 * @Author:
 * @Date: 2021-12-15 11:28:43
 * @LastEditTime: 2022-10-09 14:30:36
 * @LastEditors: lz
 * @Description:
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './assets/icons' // icon
import '@/style/common.less'
import '@/permission' // permission control
import Vant, { Notify } from 'vant'
import * as echarts from 'echarts'
import { message } from 'ant-design-vue'
import 'vant/lib/index.css'
Vue.use(Vant)
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import wx from "weixin-js-sdk";
Vue.prototype.$wx = wx;

Vue.prototype.$message = message
Vue.prototype.$notify = Notify
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Date.prototype.Format = function(fmt) {
  // author: meizz
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
  return fmt
}

Vue.use(Antd)

message.config({
  top: `40px`,
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
